// removed by extract-text-webpack-plugin
module.exports = {"component":"_1g9CIO6iG_BT_iksdjc6Hm","link":"_4ddkaQW_IZx58y3JNEdlQ","middleBox":"_34LFmdE3grMCjMfTwCVhdI","front":"o_dZXG_vw1HF-4kEOHTOr","back":"_1aa8f3pRGzoxtdQGsKgD9x"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ListPageMiddleFlip/ListPageMiddleFlip.scss
 ** module id = 987
 ** module chunks = 0
 **/